// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teamList {
  flex: 1;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
}

.teamListItem {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--paper);
  border-radius: var(--border-radius);
  padding: 0.5rem 0.9rem;
  margin-bottom: 0.6rem;
  text-align: left;
}

.teamListName {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.25rem;
}

.teamListScore {
  flex-shrink: 0;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 1rem;
  color: var(--ink-soft);
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/shared/team-list.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,mCAAmC;EACnC,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB","sourcesContent":[".teamList {\n  flex: 1;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.teamListItem {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: var(--paper);\n  border-radius: var(--border-radius);\n  padding: 0.5rem 0.9rem;\n  margin-bottom: 0.6rem;\n  text-align: left;\n}\n\n.teamListName {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.25rem;\n}\n\n.teamListScore {\n  flex-shrink: 0;\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 1rem;\n  color: var(--ink-soft);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
